import React from 'react'
import { 购物车信息 } from './'
import defaultImg from 'app/assets/images/default.png'
import { getAuthorName } from 'utils'
import './index.less'

interface SettlementTableProps {
  data?: 购物车信息
}

export default function SettlementTable({ data }: SettlementTableProps) {
  return (
    <tbody>
      <tr className="sep-row">
        <td colSpan={4}></td>
      </tr>
      <tr className="tr-bd">
        <td>
          <div className="goods">
            <div className="goods-item">
              <div className="g-img">
                <img
                  src={
                    (data?.spuType === 3 ? data?.skuImgUrl : data?.appImgUrl) ||
                    defaultImg
                  }
                  alt=""
                />
              </div>
              <div className="g-msg">
                <p className="g-name">
                  {data?.spuType === 3 ? data?.skuName : data?.spuName}
                </p>
                {[1, 4].includes(data?.spuType!) && (
                  <>
                    <p className="g-order">
                      作者：{getAuthorName(data?.authorDTOS)}
                    </p>
                    <p className="g-order">出版社：{data?.pressName}</p>
                  </>
                )}
              </div>
            </div>
          </div>
        </td>
        <td>
          <div className="amount">
            ¥<span>{data?.salePrice?.toFixed(2)}</span>
          </div>
        </td>
        <td>
          <div className="number">{data?.num}</div>
        </td>
        <td>
          <div className="amount">
            ¥<span>{data?.allSalePrice}</span>
          </div>
        </td>
      </tr>
    </tbody>
  )
}
